export const EVENTS = {
  // Heartbeat
  HEARTBEAT_PAGE_VIEWED:          "Heartbeat Page Viewed",
  HEARTBEAT_CAMPAIGN_VIEWED:      "Heartbeat Campaign Viewed",
  HEARTBEAT_CAMPAIGN_CREATED:     "Heartbeat Campaign Created",
  HEARTBEAT_CAMPAIGN_UPDATED:     "Heartbeat Campaign Updated",
  HEARTBEAT_SURVEY_SENT:          "Heartbeat Survey Sent",
  HEARTBEAT_RESPONSES_VIEWED:     "Heartbeat Responses Viewed",

  // People
  PEOPLE_PAGE_VIEWED:             "People Page Viewed",
  MEMBER_PROFILE_VIEWED:          "Member Profile Viewed",
  MEMBER_CREATED:                 "Member Created",
  MEMBER_UPDATED:                 "Member Updated",
  MEMBER_DELETED:                 "Member Deleted",
  CSV_IMPORT_STARTED:             "CSV Import Started",
  CSV_IMPORT_COMPLETED:           "CSV Import Completed",

  // Groups
  GROUPS_PAGE_VIEWED:             "Groups Page Viewed",
  GROUP_VIEWED:                   "Group Viewed",
  GROUP_CREATED:                  "Group Created",
  GROUP_UPDATED:                  "Group Updated",
  GROUP_MEMBER_ADDED:             "Group Member Added",

  // Attendance
  ATTENDANCE_PAGE_VIEWED:         "Attendance Page Viewed",
  ATTENDANCE_RECORDED:            "Attendance Recorded",

  // Connect
  CONNECT_PAGE_VIEWED:            "Connect Page Viewed",
  LINK_HUB_CUSTOMIZED:            "Link Hub Customized",
  QR_CODE_VIEWED:                 "QR Code Viewed",

  // Staff
  STAFF_PAGE_VIEWED:              "Staff Page Viewed",
  STAFF_PROFILE_VIEWED:           "Staff Profile Viewed",
  STAFF_ASSESSMENT_SENT:          "Staff Assessment Sent",
  STAFF_CHECKIN_VIEWED:           "Staff Check-in Viewed",
  STAFF_PULSE_CARE_VIEWED:        "Staff Pulse Care Viewed",

  // Volunteers
  VOLUNTEERS_PAGE_VIEWED:         "Volunteers Page Viewed",
  VOLUNTEER_PROFILE_VIEWED:       "Volunteer Profile Viewed",
  VOLUNTEER_ASSESSMENT_SENT:      "Volunteer Assessment Sent",
  VOLUNTEER_CHECKIN_VIEWED:       "Volunteer Check-in Viewed",
  VOLUNTEER_PULSE_CARE_VIEWED:    "Volunteer Pulse Care Viewed",

  // Settings
  SETTINGS_PAGE_VIEWED:           "Settings Page Viewed",
  SETTINGS_GENERAL_SAVED:         "Settings General Saved",
  SETTINGS_INTEGRATION_VIEWED:    "Settings Integration Viewed",
  SETTINGS_INTEGRATION_CONNECTED: "Settings Integration Connected",
  SETTINGS_STAFF_INVITED:         "Settings Staff Invited",
  SETTINGS_CAMPUS_CREATED:        "Settings Campus Created",
  SETTINGS_NOTIFICATIONS_SAVED:   "Settings Notifications Saved",
};
